import classNames from 'classnames';
import styles from './index.module.less';

function ServiceAgreementZH() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.serviceAgreement}>
        <div className={styles.title}>
          更新日期：【2023】年【10】 月【30】日
        </div>
        <div className={styles.title}>引言</div>
        <div>
          欢迎您使用我们的产品和服务！本《服务协议》（下称“本服务协议”）是您与
          <span className={styles.dashUnderline}>
            碳阻迹（北京）科技有限公司
          </span>
          （下称<span className={styles.dashUnderline}>“碳阻迹”</span>
          ）之间就注册碳阻迹帐号及使用碳阻迹的各项产品及服务（下称“本服务”）等相关事宜所订立的协议。为使您获得愉悦的使用体验，请您务必审慎阅读、充分理解本服务协议条款内容，
          <span className={classNames(styles.underline, styles.bold)}>
            免除或者限制责任的条款将以粗体或下划线标识，你应重点阅读。如你对协议有任何疑问，可向碳阻迹咨询。
          </span>
        </div>
        <div className={styles.title}>定义</div>
        <div>
          1.{' '}
          <span className={classNames(styles.dashUnderline, styles.bold)}>
            碳阻迹
          </span>
          ：指研发并提供碳阻迹产品和服务的
          <span className={styles.dashUnderline}>
            碳阻迹（北京）科技有限公司
          </span>
          及现在或未来设立的相关关联公司的单称或合称。
        </div>
        <div>
          2.{' '}
          <span className={styles.bold}>
            <span className={styles.underline}>碳阻迹</span>服务/本服务：
          </span>
          是指由碳阻迹开发和服务的
          <span className={styles.bold}>Carbon AI软件产品</span>
          。无论“产品/服务”属于上述何种情形，本《服务协议》都将予以适用。
        </div>
        <div>
          3.{' '}
          <span className={styles.bold}>
            <span className={styles.dashUnderline}>碳阻迹</span>网站：
          </span>
          碳阻迹为用户提供服务的互联网网址为官网(www.carbonstop.com)、碳云SaaS
          (ccloud.carbonstop.com)。
        </div>
        <div>
          4.
          <span className={styles.bold}>用户（以下或称为“您”）：</span>
          个人用户，指除授权用户外，以个人身份注册和使用本服务的自然人；客户，指通过授权自然人注册本服务帐号，享有管理权限的法人或其他组织，客户可以邀请个人加入其组织成为其授权用户；授权用户，指被客户授权或邀请加入，并使用本服务的自然人。
        </div>
        <div className={styles.title}>特别提示</div>
        <div>
          1、
          <span className={styles.bold}>
            如您在注册登录时勾选“我已阅读并同意《服务协议》”并通过注册程序或其他任何方式使用或接受本服务，即视为您已阅读并同意本服务协议内容，自愿接受本服务协议的所有内容的约束。如您不同意本服务协议的任意内容，请勿注册或使用本服务，并应立即停止注册程序。
          </span>
          如您对本服务协议的内容（特别是涉及免除或者责任限制的条款）有任何疑义，可随时按照本服务协议中列明的联系方式与我们联系，我们将根据您的要求为您进一步解释和说明相关内容。
        </div>
        <div>
          2、
          <span className={styles.bold}>
            基于业务功能、使用规则、法律法规及监管要求、更好的提供服务、经营策略等原因，
          </span>
          本协议可能变更，<span className={styles.dashUnderline}>碳阻迹</span>
          对本协议内容进行的重大变更，我们会提供显著的通知(包括我们会通过碳阻迹网站公示的方式进行通知)。
          <span className={styles.bold}>
            修改后的协议及规则自公布后即时生效。我们还会将本服务协议的旧版本存档，供您查阅。若您在本服务协议修订后继续使用碳阻迹服务，这表示您已充分阅读、理解并接受修订后的本服务协议并愿意受修订后的本服务协议约束。
          </span>
        </div>
        <div>
          3、
          <span className={styles.bold}>
            为使您能够享受本服务的功能，我们会在遵守相关法律法规的情况下，收集、使用、共享您信息，我们仅根据客户要求处理您的信息，且不对该客户的相关行为承担法律责任。您的个人信息及相关处理请您详细查阅《隐私政策》。
          </span>
        </div>
        <div>
          4、
          <span className={styles.bold}>
            当您注册本服务的帐号后，您可以使用本服务提供的部分功能；当您订阅购买产品服务或接受其他客户组织邀请后，您将获得本服务对应的全部功能。
          </span>
        </div>
        <div>
          5、
          <span className={styles.bold}>
            本服务及相关衍生服务的所有权、运作权及有关权益归我们所有。
          </span>
        </div>
        <div className={styles.title}>服务协议明细</div>
        <div className={styles.title}>一、帐号注册和使用规范</div>
        <div>
          1、本服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建帐户。
          <span className={classNames(styles.bold, styles.underline)}>
            如果您未满18周岁，请务必在家长和其他法定监护人的陪同下阅读本服务协议，并在进行注册等任何行为或使用本服务，事先征得您的家长和其他法定监护人的同意。
          </span>
        </div>
        <div>
          2、
          <span className={classNames(styles.bold, styles.underline)}>
            如果你是非中国大陆地区的用户，你订立或履行本协议以及使用本服务的行为还需要同时遵守你所属和/或所处国家或地区的法律。
          </span>
        </div>
        <div>
          3、您可以通过本服务提供的注册界面，根据页面提示填写信息、阅读并同意本服务协议且完成全部注册程序后，你可获得本服务帐号并成为本服务用户。
        </div>
        <div>
          4、<span className={styles.bold}>使用同一手机号</span>或经
          <span className={styles.dashUnderline}>碳阻迹</span>
          排查认定多个服务帐号的实际控制人为同一人的，均视为同一用户。
        </div>
        <div>
          5、您应当通过真实身份信息认证注册帐号，且您提交的帐号名称、头像、
          简介等注册信息中不得出现违法和不良信息，如存在上述情况，
          <span className={styles.dashUnderline}>碳阻迹</span>将不予注册；
          <span className={classNames(styles.bold, styles.underline)}>
            同时，在注册后，如发现你以虚假信息骗取帐号名称注册，或帐号头像、简介等注册信息存在违法/不良信息的，或侵犯他人合法权益的，碳阻迹可采取限期改正、暂停使用、注销登记、收回等措施。
          </span>
        </div>
        <div>
          6、
          <span className={styles.bold}>
            您有权使用手机号或邮箱登录本服务，获得帐号并自行设置符合安全要求的密码，
          </span>
          您的帐号由您自行保管，
          <span className={styles.dashUnderline}>碳阻迹</span>
          任何时候均不会主动要求您提供您的帐号密码。因此，请您务必保管好您的帐号，并确保您在每个上网时段结束时退出登录并以正确步骤离开本服务。
          <span className={classNames(styles.bold, styles.underline)}>
            帐号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，碳阻迹并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
          </span>
        </div>
        <div>
          7、
          <span className={styles.bold}>
            由于您的服务帐号关联您的个人信息及业务信息，请确保您的帐号仅限您本人使用，以保证帐号的安全性和私密性。
            <span className={styles.underline}>
              您应对您帐号项下的所有行为结果（包括但不限于企业信息填写、业务数据填写、购买商品/服务及披露信息等）负责，但碳阻迹存在过错的除外。
            </span>
          </span>
        </div>
        <div>
          8、
          <span className={classNames(styles.bold, styles.underline)}>
            如发现任何未经授权使用您帐号登录碳云或其他可能导致您帐号遭窃、遗失的情况，建议您立即通知碳阻迹客服。您应理解碳阻迹对您的任何请求采取行动均需要合理时间，且碳阻迹应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除碳阻迹存在法定过错外，碳阻迹不承担责任。
          </span>
        </div>
        <div>
          9、由于用户帐号关联用户个人及企业信息，当符合碳云用户帐号转让流程的情况下，您可进行帐号的转让。您的帐号一经转让，该帐号项下权利义务一并转移。
          <span className={classNames(styles.bold, styles.underline)}>
            除此外，您的帐号不得以任何方式转让，否则碳阻迹有权追究您的违约责任，且由此产生的责任及后果均由您自行承担。
          </span>
        </div>
        <div>
          10、因您个人原因导致的帐号信息遗失，如需找回帐号信息，请按照帐号找回要求提供相应的信息，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过安全验证，碳阻迹有权拒绝提供帐号找回服务；若帐号的唯一凭证不再有效，碳阻迹有权拒绝支持帐号找回，例如手机号二次出售，碳阻迹可拒绝支持帮助找回原手机号绑定的帐号。
        </div>
        <div>
          11、在需要终止使用本服务时，您可以向
          <span className={styles.dashUnderline}>碳阻迹</span>
          客服提出注销申请。若您是授权用户，您可以向您所在的企业或组织提交退出团队申请并注销帐号，由客户管理员处理。在您的帐号被注销前，我们将验证您的个人身份、安全状态、设备信息等信息，您知悉并理解，注销帐号的行为是不可逆的行为，
          <span className={styles.bold}>
            在注销帐户之后，我们将停止为您提供服务，并依据您的要求，删除您的个人信息或对您的个人信息进行匿名化处理，但法律法规另有规定的除外。
          </span>
        </div>
        <div>
          12、若您在本服务注册、使用期间存在违反法律规定的情形，
          <span className={styles.bold}>
            我们保留在您违反适用法律法规规定或违反本协议的情况下冻结、注销您的帐号并删除或匿名化处理您所存储的数据、信息的权利，且无需为此向您承担任何责任，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。
          </span>
        </div>
        <div className={styles.title}>二、服务内容及使用规范</div>
        <div>
          1、
          <span className={styles.bold}>
            您具体享受的服务周期，将从您实际购买日起算。
          </span>
        </div>
        <div>
          2、您可使用本服务进行碳相关业务计算及数据管理，您需保证您使用本服务上传的模型、数据、附件、产品、服务的安全性、稳定性、有效性，不存在病毒、蠕虫、木马及其他有害的计算机的代码、文件、脚本和程序，不会对我们的相关系统及数据造成损害。由于您的内容引起的安全漏洞，包括但不限于病毒、木马、蠕虫或其他有害程序，或由于您未按照本协议约定使用服务而引起的安全漏洞，由您自行负责并承担责任，如造成我们损失或损失风险的，我们有权向您主张损害赔偿责任。
        </div>
        <div>
          3、若您为企业管理员，您可启用或禁用授权用户对本服务的访问权限。企业用户的选择和决定可能会使您的部分或全部用户内容被访问、使用、披露、修改、限制使用或删除。如果您代表客户使用本服务，您确认客户将事先向其授权用户就此情况进行充分说明，并取得授权用户的明确同意。
        </div>
        <div className={styles.title}>三、隐私、帐号及密码的保护</div>
        <div>
          1、<span className={styles.dashUnderline}>碳阻迹</span>
          非常重视用户的个人信息和隐私的保护，《隐私政策》为本服务协议的一部分。碳阻迹将按照《隐私政策》中所公布的政策在本服务中进行隐私及个人信息的收集、存储、使用、披露等活动。用户在使用本服务前，应仔细阅读《隐私政策》。
        </div>
        <div>
          2、各方应就本服务协议内容，以及本服务协议签署和履行过程中所获知的另一方保密信息（指另一方尚未通过公开途径披露的任何信息，包括用户使用本服务保存在碳阻迹服务器上的数据、开发服务内容、成果、相关文件、资料等）严格保密，未经对方事先书面同意，不得向任何第三方泄露保密信息，但由于法律的适用、法院或应国家有权机关的要求而披露的除外。
        </div>
        <div>
          3、用户应就登录密码采取保密措施，
          <span className={styles.dashUnderline}>碳阻迹</span>
          不会以任何方式向用户索要登录密码，用户不得向其他任何第三方透露登陆密码，否则用户可能需对碳阻迹及本服务的任何其他用户或访问者因此所遭受的损失承担责任。
        </div>
        <div>
          4、本服务协议终止后，本保密条款继续有效。任何一方违反任何保密义务的，应当赔偿由此给对方造成的损失。
        </div>

        <div className={styles.title}>四、知识产权</div>
        <div>
          1、除另有说明外，本服务所载的内容为
          <span className={styles.dashUnderline}>碳阻迹</span>
          的财产，表现形式包括但不限于文本、图像、数据、信息、软件、图形、照片、观点、建议、网页等。碳阻迹可随时更改本服务上的内容，而无需通知。碳阻迹将尽可能提供准确的数据结果，但我们对信息的准确性和完整性不承担任何义务或责任。为方便您的使用，本服务可能包含指向第三方网站的链接，但包含链接并不意味着此类网站或其中提供的产品或服务的任何认可，也不保证所提供信息的有效性。
        </div>
        <div>
          2、<span className={styles.dashUnderline}>碳阻迹</span>完全拥有Carbon
          AI及本服务的全部知识产权（包括但不限于商标权、著作权、专利权、商业秘密等），您仅基于本服务协议取得有限的使用权。碳阻迹软件及本服务的名称、LOGO、商业标识等相关权利均归属于碳阻迹，未经碳阻迹授权，您不得使用或授权第三方使用。您同意经碳阻迹授权后使用本服务内容时注明内容来源为“碳阻迹”。
        </div>
        <div>
          3、如因<span className={styles.dashUnderline}>碳阻迹</span>
          原因出现与Carbon
          AI软件有关的第三方指控或知识产权侵权等事件，我们负责解决。但因如下情况引起的第三方指控或侵权等事件、以及由此产生的一切责任均由用户自行承担，碳阻迹不承担任何责任：
        </div>
        <div>
          <div className={styles.circle}></div>当最新版本的Carbon
          AI软件已向用户提供，而使用这种最新版本的软件又能避免上述指控或侵权事件，但用户还采用其他版本；
        </div>
        <div>
          <div className={styles.circle}></div>用户将Carbon
          AI软件与其他的软件、程序或数据一起使用导致上述指控或侵权事件发生；
        </div>
        <div>
          <div className={styles.circle}></div>未经
          <span className={styles.dashUnderline}>碳阻迹</span>
          事先同意，用户自行对Carbon
          AI软件进行修改、改编、反编译、反汇编等任何形式的处理而导致的指控或侵权事件。
        </div>
        <div className={styles.title}>五、服务</div>
        <div>1、除本服务协议其他条款约定外，本服务协议还可因下列情形终止：</div>
        <div>
          <div className={styles.circle} />
          经双方协商一致，本服务协议可提前终止；
        </div>
        <div>
          <div className={styles.circle} />
          一方发生违约行为，且经对方催告后未能在5日内纠正违约行为并消除违约影响，则另一方有权解除本服务协议；
        </div>
        <div>
          <div className={styles.circle} />
          如一方成为申请破产主体，或成为任何其它资不抵债、接管、清算等程序的对象，则另一方有权解除本服务协议；
        </div>
        <div>
          <div className={styles.circle} />
          如因不可抗力事件影响导致一方或双方无法履行本服务协议项下义务且持续时间超过30日，则任何一方有权解除本服务协议；
        </div>
        <div>
          <div className={styles.circle} />
          <span className={styles.dashUnderline}>碳阻迹</span>
          收回、注销用户帐号，此情形下，本服务协议于帐号收回、注销之日终止；
        </div>
        <div>
          <div className={styles.circle} />
          在满足帐号注销条件时，用户注销帐号，本服务协议于帐号注销之日终止；
        </div>
        <div>
          <div className={styles.circle} />
          <span className={styles.dashUnderline}>碳阻迹</span>
          有权根据自身商业安排经过合理的提前通知终止本服务，本服务协议于本服务依法定程序及方式终止之日终止。
        </div>
        <div>
          2、本服务协议终止后，
          <span className={styles.dashUnderline}>碳阻迹</span>
          将无法继续向用户提供任何服务或履行任何其他义务，包括但不限于为用户保留或向用户披露其帐号中的任何信息等。
        </div>
        <div>
          3、本服务协议的终止不影响知识产权条款以及其他根据其内容应继续有效的条款的有效性，也不影响本服务协议终止前各方的相关权利和义务，包括但不限于守约方依据本服务协议向违约方追究相应的违约责任。
        </div>

        <div className={styles.title}>六、服务声明</div>
        <div>
          <span className={styles.dashUnderline}>碳阻迹</span>
          对下列事项不作陈述与保证：
        </div>
        <div>
          <div className={styles.circle} />
          <span className={styles.dashUnderline}>碳阻迹</span>
          尽可能向用户提供正常稳定的Carbon AI软件服务，但在Carbon
          AI软件与用户所使用的特定软件和硬件（如系统、手机、电脑）发生了不兼容或者报错等情形，碳阻迹不能保证上述情形不会发生；
        </div>
        <div>
          <div className={styles.circle} />
          鉴于Carbon
          AI软件服务是标准化的软件服务，碳阻迹不能保证根据用户的个性化要求对碳云软件服务进行特别的修正。
        </div>
        <div>
          <div className={styles.circle} />
          Carbon
          AI软件是通过标准化的计算模型产生结果，碳阻迹不能保证结果或报告的绝对准确或不具有任何误导性，亦不承担用户以任何方式使用该等结果或报告所产生的一切责任或义务，包括但不限于因该等结果或报告的合理误差、遗漏或其他问题产生的责任或义务。
        </div>
        <div>
          <div className={styles.circle} />
          在适用法律法规所允许的最大范围内，
          <span className={styles.dashUnderline}>碳阻迹</span>
          不就因使用或不能使用本服务所引起的或有关的任何间接的、意外的、特殊的、惩罚性的或其它任何损害（包括但不限于因人身伤害或财产损坏而造成的损害，因利润损失、数据损失、营业中断、计算机瘫痪或故障、商业信息的遗失而造成的损害）承担赔偿责任。
        </div>
        <div className={styles.title}>七、第三方内容的使用</div>
        <div>
          1、本服务可能包含或向用户提供第三方内容，如ecoinvent等数据库授权使用的数据等。
          <span className={styles.dashUnderline}>碳阻迹</span>
          不对任何此类第三方内容作出任何形式的陈述或保证，也不对任何第三方内容造成的任何性质或种类的损失、损害、费用或成本承担任何责任。
        </div>
        <div className={styles.title}>八、通知</div>
        <div>1、有效联系方式</div>
        <div>
          您在注册或使用碳阻迹服务时，您应该向
          <span className={styles.dashUnderline}>碳阻迹</span>
          提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被有效联系的状态。
        </div>
        <div>
          您用于登陆<span className={styles.dashUnderline}>碳阻迹</span>
          平台、接收站内信、系统消息等即时信息的账号，也作为您的有效联系方式。
        </div>
        <div>
          <span className={styles.dashUnderline}>碳阻迹</span>
          公司将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
        </div>
        <div>2、通知的送达</div>
        <div>
          <span className={styles.dashUnderline}>碳阻迹</span>
          通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在碳阻迹官网平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
        </div>
        <div>
          您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
        </div>
        <div>您可通过以下方式与我们联系：</div>
        <div>电子邮件：mail@carbonstop.com</div>
        <div>电话：+86（010）50973498</div>
        <div className={styles.title}>九、违约责任</div>
        <div>1、违约认定</div>
        <div>发生如下情形之一的，视为您违约：</div>
        <div>
          使用<span className={styles.dashUnderline}>碳阻迹</span>
          产品或服务时违反有关法律法规规定的；
        </div>
        <div>违反本协议、关联协议或者与碳阻迹签署的其他协议约定的。</div>
        <div>2、违约处理措施</div>
        <div>
          您在<span className={styles.dashUnderline}>碳阻迹</span>
          平台上发布的信息构成违约的，碳阻迹可根据相应平台规则立即对相应信息进行删除、屏蔽处理。
        </div>
        <div>
          您在<span className={styles.dashUnderline}>碳阻迹</span>
          平台上实施的行为，或虽未在碳阻迹平台上实施但对碳阻迹及其用户产生影响的行为构成违约的，碳阻迹可依据相应平台规则对您执行中止向您提供部分或全部产品或服务等处理措施。如您的行为构成根本违约的，碳阻迹可关闭您的账号，终止向您提供产品或服务。
        </div>
        <div>
          当您违约的同时存在欺诈、售假、盗用他人账号等特定情形或您存在危及他人账号安全风险时，碳阻迹会依照您行为的风险程度对您的账号采取关闭、注销等强制措施。
        </div>
        <div>
          <span className={styles.dashUnderline}>碳阻迹</span>
          可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在碳阻迹平台上予以公示。
        </div>
        <div>3、赔偿责任</div>
        <div>
          如您的行为使<span className={styles.dashUnderline}>碳阻迹</span>
          遭受损失，您应根据本协议履行赔偿责任，您需赔偿碳阻迹的因此遭受的损失（如有）包括:
        </div>
        <div>支付的合理律师费、诉讼费、消除影响所支出的必要费用；</div>
        <div>
          因行政处罚、司法裁判、法定标准范围内的调解等对外支出的罚款、违约金或赔偿金；
        </div>
        <div>
          商誉损失、合理预期利益损失（如经营收入减少等），具体金额可以第三方独立合理分析、碳阻迹根据大数据合理分析及其他计算收益、损失的合理方法所得出的相关估算标准作为计算依据；
        </div>
        <div>因此遭受的其他损失。</div>
        <div>
          如您的行为使<span className={styles.dashUnderline}>碳阻迹</span>
          遭受第三人主张权利，碳阻迹可在对第三人承担金钱给付等义务后就全部损失向您追偿。
        </div>
        <div>
          <span className={styles.dashUnderline}>碳阻迹</span>
          因故意或重大过失违约导致您利益受损的，碳阻迹将以您的直接实际损失为计算依据向您履行赔偿责任。
        </div>
        <div className={styles.title}>十、争议解决及其他</div>
        <div>
          1、本服务协议适用中华人民共和国（为本服务协议之目的，不含香港特别行政区、澳门特别行政区、台湾）法律。
        </div>
        <div>
          2、因履行本服务协议所发生的一切争议，双方应通过友好协商解决；协商不成时，任何一方均可向
          <span className={styles.dashUnderline}>碳阻迹</span>
          所在地有管辖权的人民法院提起诉讼。
        </div>
      </div>
    </div>
  );
}

export default ServiceAgreementZH;
